import { render, staticRenderFns } from "./HotKeys.vue?vue&type=template&id=6977f348"
import script from "./HotKeys.vue?vue&type=script&lang=js"
export * from "./HotKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports